
import { Link } from "react-router-dom";
import GulfStudentsData from "../Data/Gulf_Students/GulfStudentsData";
import "../Gulf_Students/CSS/GulfStudentsCSS.css";
import "../Gulf_Students/CSS/ThanksPage.css";
import PdfFile from "../lorem-ipsum.pdf";

const AcademicReadinessSuccess = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = PdfFile;
    link.download = "lorem-ipsum.pdf"; // download hone wali file ka naam
    link.click();
  };
  return (
    <>
      <section className="thank-you-page-main-section">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 thank-you-page-heading-para-div">
              <h1>Thank you for submitting the request.</h1>
              <h2>Welcome to the Bootcamp!</h2>
              <h4>Your first lesson will be one click away.</h4>
              <button onClick={handleDownload}>Download It Now</button>
              <h2>Want to meet Gulf students already studying abroad?</h2>
              <h4>Join our Peer Mentorship Network.</h4>
              <Link to={"/gulf-students/mentorship"}><button>Meet My Mentor</button></Link>
            </div>
          </div>
        </div>
      </section>
      <section className="other-services-section-start-here">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-md-12 other-services-heading-div">
              <h2>Other <span>Services</span></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
            {
              GulfStudentsData.filter(item => item.id !== 2)
                .map((item) => {
                  return (
                    <div className="col our-services-card-div" key={item.id}>
                      <div className="our-services-card-inner-div">
                        <div className="what-we-offer-card-icon">
                          <img src={item.bannerImg} alt="" />
                        </div>
                        <h5>{item.heading}</h5>
                        <p>{item.text}</p>
                        {item.link}
                      </div>
                    </div>
                  )
                })
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default AcademicReadinessSuccess